document.addEventListener('DOMContentLoaded', () => {
    const allFooterMenu = document.querySelectorAll('.footer__menu-title');

    // update the ada compilant attributes on 1024 screen size
    if(window.innerWidth > 1023) {
        allFooterMenu.forEach(el => {
            el.setAttribute('aria-expanded', 'true');
            const itemsContainer = el.parentElement.querySelector('.footer__menu-items');
            itemsContainer.setAttribute('aria-hidden', 'false');
        })
    }

    allFooterMenu.forEach((el) => {
      const itemsContainer = el.parentElement.querySelector('.footer__menu-items');
      el.addEventListener('click', () => {
        const isExpanded = el.getAttribute('aria-expanded') === 'true';
        // Close all items
        document.querySelectorAll('.footer__menu-items').forEach((item) => {
          if (item !== itemsContainer) {
            item.style.height = null;
            item.parentElement.classList.remove('open');
            item.setAttribute('aria-hidden', 'true');
            item.previousElementSibling.setAttribute('aria-expanded', 'false');
            item.classList.remove('is-open');
          }
        });
  
        // Toggle the clicked item
        if (isExpanded) {
          itemsContainer.style.height = null;
          el.setAttribute('aria-expanded', 'false');
          itemsContainer.setAttribute('aria-hidden', 'true');
          itemsContainer.classList.remove('is-open');
        } else {
          itemsContainer.style.height = itemsContainer.scrollHeight + 'px';
          el.setAttribute('aria-expanded', 'true');
          itemsContainer.setAttribute('aria-hidden', 'false');
        }
  
        // Toggle the parent open class
        el.parentElement.classList.toggle('open', !isExpanded);
      });
  
      // Ensure the toggle is keyboard accessible
      el.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') { // Enter or Space
          event.preventDefault();
          el.click();
        }
      });
    });
});
  